// import React, { useState, useEffect } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { Menu, X } from "lucide-react";
// // import "./Navbar.css";

// const navItems = [
//   { name: "Home", href: "/" },
//   { name: "About Us", href: "/aboutPage" },
//   { name: "Services", href: "/servicespage" },
//   { name: "Career", href: "/careerpage" },
//   { name: "Contact Us", href: "/contactus" },
//   { name: "Privacy Policy", href: "/privacypage" },
//   { name: "Terms & Conditions", href: "/termpage" },
//   {
//     name: "Products",
//     href: "/products",
//     dropdown: true,
//     children: [
//       // { name: "Crm-Laundry", href: "/CrmLaundry" },
//       // { name: "Cylinder Management", href: "/Cylinder" },
//       // { name: "Crm-Car-Service", href: "/CrmCarWash" },
//       // { name: "Inventory-Management", href: "/WaterJarManagement" },
//       // { name: "Crm-Salon", href: "/CrmSaloon" },
//       // { name: "Invoice Generator", href: "/Invoice" },
//       // { name: "CRM-Realtify", href: "/realitify" },
//       // { name: "Image To Excel Converter", href: "/ImageExcel" },
//       { name: "HRMS (Human Resource Management System)", href: "https://hrmsm.com/home" },
//       { name: "ERP (Enterprise Resource Planning)", href: "/erp" },
//       {
//         name: "AIFaceTrack (AI-Based Attendance & Security)",
//         href: "/aifacetrack",
//       },
//       { name: "CRM (Customer Relationship Management)", href: "/crm" },
//       { name: "QMS (Queue Management System)", href: "/qms" },
//       { name: "POS (Point of Sale System)", href: "/pos" },
//       // { name: "BulkEmail", href: "/BulkEmail" },
//       // { name: "Hrmsm For School", href: "https://hrmsm.com/homeKidz" },
//       // { name: "RedCarpet", href: "/RedCarpet" },
//       // { name: "Mediscan", href: "/Mediscan" },
//       // { name: "OrderEasy", href: "/OrderEasy" },
//       // { name: "Medichart", href: "/Medichart" },
//       // { name: "QR-Black", href: "/QrBlack" },
//     ],
//   },
// ];

// export default function Navbar() {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth < 768);
//       if (window.innerWidth >= 768) setMobileMenuOpen(false);
//     };
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);
//   const location = useLocation();

//   return (
//     <>
//       <div className="navbar">
//         <div className="navbar-container">
//           <div className="logo">
//             <Link to="/" className="scrolled-logo">
//               <div className="ll"></div>
//             </Link>
//           </div>

//           {/* Desktop Navigation */}
//           <nav className={`nav-links ${isMobile ? "hide" : ""}`}>
//             {navItems.map((item) => {
//               if (item.dropdown) {
//                 return (
//                   <div className="dropdown" key={item.name}>
//                     <Link to={item.href} className="scrolled-link">
//                       {item.name} 🡻
//                     </Link>
//                     <div className="dropdown-menu">
//                       {item.children.map((child) => (
//                         <Link
//                           key={child.name}
//                           to={child.href}
//                           className={`dropdown-item ${
//                             location.pathname === child.href ? "active" : ""
//                           }`}
//                         >
//                           {child.name}
//                         </Link>
//                       ))}
//                     </div>
//                   </div>
//                 );
//               } else {
//                 return (
//                   <Link
//                     key={item.name}
//                     to={item.href}
//                     className={`scrolled-link ${
//                       location.pathname === item.href ? "active" : ""
//                     }`}
//                   >
//                     {item.name}
//                   </Link>
//                 );
//               }
//             })}
//           </nav>
//           <a href="/startcontact">
//             <button className="get-started-btn">Get Started</button>
//           </a>

//           {/* Mobile Menu Button */}
//           <button
//             className="menu-toggle"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//           >
//             {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
//           </button>
//         </div>

//         {/* Mobile Navigation */}
//         <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
//           {navItems.map((item) => {
//             if (item.dropdown) {
//               return (
//                 <div key={item.name} className="mobile-dropdown">
//                   <span className="mobile-dropdown-title">{item.name}</span>
//                   <div className="mobile-dropdown-menu">
//                     {item.children.map((child) => (
//                       <Link
//                         key={child.name}
//                         to={child.href}
//                         onClick={() => setMobileMenuOpen(false)}
//                         className={
//                           location.pathname === child.href ? "active" : ""
//                         }
//                       >
//                         {child.name}
//                       </Link>
//                     ))}
//                   </div>
//                 </div>
//               );
//             } else {
//               return (
//                 <Link
//                   key={item.name}
//                   to={item.href}
//                   onClick={() => setMobileMenuOpen(false)}
//                   className={location.pathname === item.href ? "active" : ""}
//                 >
//                   {item.name}
//                 </Link>
//               );
//             }
//           })}
//         </div>
//       </div>
//       <style>
//         {`

//  /* Navbar Container */

//  .scrolled-link{
//    font-size: 18px;
//    color:rgb(6, 0, 59);
//    margin-top: -2px;
//   // text-shadow: 0 0.5px 2px rgb(0, 0, 0);
//  }

//  .scrolled-link.active,
// .dropdown-item.active {
//   background-color:rgb(37, 85, 218);
//   color: white;
//   border-radius: 6px;
//   padding: 6px 12px;
// }

// .mobile-menu a.active {
//   background-color:rgb(37, 85, 218);
//   color: white;
//   border-radius: 6px;
//   padding: 8px 12px;
//   display: block;
// }

// .navbar {
//   width: 100%;
//   // background: rgba(0, 153, 255, 0.554);
//   background: linear-gradient(to right,rgb(255, 255, 255),rgba(31, 115, 184, 0.66));

//   // background: linear-gradient(to bottom right,rgba(0, 89, 255, 0.75),rgba(248, 244, 244, 0.74),rgba(0, 110, 255, 0.8));
//   backdrop-filter: blur(17px);
//   position: fixed;
//   top: 0;
//   left: 0;
//   z-index: 1000;
//   /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
// }

// .navbar-container {
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   padding: 10px 20px;
//   max-width: 1500px;
//   margin: auto;
// }

// /* Logo */
// .logo a {
//   font-size: 24px;
//   font-weight: bold;
//   text-decoration: none;
//   color: #fcfcfc;
// }

// .logo span {
//   color:rgb(0, 202, 252);
//   text-shadow: 0 0 2px rgb(255, 255, 255);
// }

// /* Desktop Navigation */
// .nav-links {
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   gap: 30px;
// }

// .nav-links a {
//   text-decoration: none;
//   color:rgb(6, 0, 59);
//   font-size: 18px;
//   font-weight: 600;
//   transition: 0.3s;
//   // text-shadow: 0 0.5px 2px rgb(0, 0, 0);
// }

// .nav-links a:hover {
//   color: #e1e1e1c0;
// }

// /* Get Started Button */
// .get-started-btn {
//   background: #007bff;
//   color: white;
//   padding: 10px 20px;
//   border: none;
//   border-radius: 25px;
//   cursor: pointer;
//   font-size: 16px;
//   transition: 0.3s;
// }

// .get-started-btn:hover {
//   background: #0056b3;
// }

// /* Mobile Menu Button */
// .menu-toggle {
//   display: none;
//   background: none;
//   border: none;
//   color: white;
//   cursor: pointer;
// }

// /* Mobile Navigation */
// .mobile-menu {
//   display: none;
//   flex-direction: column;
//   position: absolute;
//   top: 58px;
//   left: 0;
//   z-index: 2;
//   // margin-bottom: 30px;
//   width: 100%;
//   background: white;
//   box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
//   padding: 10px 0;
//   max-height: 80vh;
//   overflow-y: auto;
// }

// .scrolled-logo{
//   color: white;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }

// .ll{
// height: 70px;
// width: 280px;
// position: relative;
// // background:rgba(169, 213, 255, 0.66);
// // border-style: solid;
// // border-radius: 5px;
// // border-color: rgb(113, 172, 248);
// // background: white;
// background-image: url("/images/log.png");
// background-size: cover;
// background-position: center;
// }

// .mobile-menu a {
//   padding: 10px 20px;
//   text-decoration: none;
//   color: #333;
//   display: block;
//   transition: 0.3s;
// }

// .mobile-menu a:hover {
//   background: #f0f0f0;
//   zindex: 9;
// }

// /* Responsive Design */
// @media (max-width: 1132px) {
//   .navbar-container {
//   padding: 8px 20px;
//   }

//   .nav-links {
//     gap: 10px;
//   }

//   .nav-links a {
//     font-size: 14px;
//   }

//   .get-started-btn {
//     padding: 8px 16px;
//     font-size: 14px;
//   }
// }

// @media (max-width: 1320px) {
//   .nav-links {
//     display: none;
//   }

//   .menu-toggle {
//     display: block;
//   }
//   .get-started-btn {
//     position: absolute;
//     right: 57px;
//     // width: 100px;
//     top: 20px;
//     padding: 14px 18px;
//   }

//   .mobile-menu.open {
//     display: flex;
//     margin-top: 18px;
//   }
// }

// @media (max-width: 600px){
// .ll{
//   height: 60px;
//   width: 230px;
//   }

//   .get-started-btn {
//     top: 15px;
//     display: none;
//   }
// }

// /* Desktop Dropdown */
// .dropdown {
//   position: relative;
//   color: white;
//   font-weight: 600;
//   font-size: 16px;
//   bottom: 1px;
//   /* background-color: red; */
// }

// .dropdown:hover {
//   color: #e1e1e1c0;
// }

// .dropdown-menu {
//   position: absolute;
//   background: rgba(173, 173, 173, 0.81);
//   // background: white
//   backdrop-filter: blur(12px);
//   box-shadow: 0px 4px 8px rgba(0,0,0,0.1);
//   padding: 10px 0;
//   top: 100%;
//   right: 0;
//   display: none;
//   min-width: 600px;
//   z-index: 100;
// }

// .dropdown:hover .dropdown-menu {
//   display: block;
//   display: grid;
//    backdrop-filter: blur(6px);
//     grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
// }

// .dropdown-item {
//   padding: 8px 16px;
//   display: block;
//   // color: black;
//   // text-decoration: none;
// }

// .dropdown-item:hover {
//   background-color: #1392fa64;
// }

// /* Mobile Dropdown */
// .mobile-dropdown {
//   margin: 10px 0;
// }

// .mobile-dropdown-title {
//   font-weight: bold;
//   display: block;
//   padding: 8px 0;
//   margin-left: 20px;
// }

// .mobile-dropdown-menu {
//   padding-left: 19px;
// }

// .mobile-dropdown-menu a {
//   display: block;
//   padding: 5px 0;
// }

//       `}
//       </style>
//     </>
//   );
// }
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ChevronRight } from "lucide-react";

const navItems = [
  { name: "Home", href: "/" },
  { name: "About Us", href: "/aboutPage" },
  { name: "Services", href: "/servicespage" },
  { name: "Gallery", href: "/gallery" },
  { name: "Career", href: "/careerpage" },
  { name: "Contact Us", href: "/contactus" },

  // { name: "Privacy Policy", href: "/privacypage" },
  // { name: "Terms & Conditions", href: "/termpage" },
  {
    name: "Products",
    href: "/products",
    dropdown: true,
    children: [
      { name: "HRMS (Human Resource Management System)", href: "https://hrmsm.com/home" },
      // { name: "ERP (Enterprise Resource Planning)", href: "/erp" },
      {
        name: "AIFaceTrack (AI-Based Attendance & Security)",
        href: "/aifacetrack",
      },
      { name: "CRM (Customer Relationship Management)", href: "/crm" },
      { name: "QMS (Queue Management System)", href: "/qms" },
      { name: "ERP (Enterprise Resource Planning)", href: "/contact" },
      { name: "POS (Point of Sale System)", href: "/contact" },
      { name: "AI Automation (Marketing Automation Platform)", href: "/contact" },
      { name: "VMS (Vendor Management System)", href: "/contact" },
      { name: "DMS (Dealer Management System)", href: "/contact" },
      { name: "Supply & Logistics (Supply Chain & Logistics Management)", href: "/contact" },
      { name: "Task Allocation (Task & Workforce Management System)", href: "/contact" },
      { name: "LMS (Learning Management System)", href: "/contact" },

    ],
  },
];

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 850);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 850;
      setIsMobile(mobile);
      if (!mobile) setMobileMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const location = useLocation();

  return (
    <>
      <div className="navbar">
        <div className="navbar-container">
          <div className="logo">
            <Link to="/" className="scrolled-logo">
              <div className="ll"></div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className={`nav-links ${isMobile ? "hide" : ""}`}>
            {navItems.map((item) => {
              if (item.dropdown) {
                return (
                  <div className="dropdown" key={item.name}>
                    <Link
                      to={item.href}
                      className="scrolled-link dropdown-toggle"
                    >
                      {item.name}
                      <svg
                        className="dropdown-arrow"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4 6L8 10L12 6"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </Link>
                    <div className="dropdown-menu modern-dropdown">
                      {item.children.map((child, index) => (
                        <Link
                          key={child.name}
                          to={child.href}
                          className={`dropdown-item modern-dropdown-item ${location.pathname === child.href ? "active" : ""
                            }`}
                          style={{ "--item-index": index }}
                        >
                          <div className="dropdown-item-content">
                            <div className="dropdown-item-icon">
                              <ChevronRight size={18} />
                            </div>
                            <div className="dropdown-item-text">
                              <span className="dropdown-item-name">
                                {child.name}
                              </span>
                            </div>
                          </div>
                          <div className="dropdown-item-hover-bg"></div>
                        </Link>
                      ))}
                    </div>
                  </div>
                );
              } else {
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`scrolled-link ${location.pathname === item.href ? "active" : ""
                      }`}
                  >
                    {item.name}
                  </Link>
                );
              }
            })}
          </nav>

          <div className="nav-right">
            <a href="/startcontact" className="get-started-link">
              <button className="get-started-btn">Get Started</button>
            </a>

            {/* Mobile Menu Button */}
            <button
              className="menu-toggle"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
          {navItems.map((item) => {
            if (item.dropdown) {
              return (
                <div key={item.name} className="mobile-dropdown">
                  <button
                    className="mobile-dropdown-title"
                    onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
                  >
                    <span>{item.name}</span>
                    <svg
                      className={`mobile-dropdown-arrow ${mobileDropdownOpen ? "open" : ""}`}
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 7.5L10 12.5L15 7.5"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </button>
                  {mobileDropdownOpen && (
                    <div className="mobile-dropdown-menu">
                      {item.children.map((child) => (
                        <Link
                          key={child.name}
                          to={child.href}
                          onClick={() => {
                            setMobileMenuOpen(false);
                            setMobileDropdownOpen(false);
                          }}
                          className={
                            location.pathname === child.href ? "active" : ""
                          }
                        >
                          {child.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              );
            } else {
              return (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className={location.pathname === item.href ? "active" : ""}
                >
                  {item.name}
                </Link>
              );
            }
          })}
        </div>
      </div>
      <style>
        {`
      
 /* Navbar Container */

 .scrolled-link{
   font-size: 17px;
   color:rgb(6, 0, 59);
   margin-top: -2px;
   display: flex;
   align-items: center;
   gap: 6px;
   transition: all 0.3s ease;
  // text-shadow: 0 0.5px 2px rgb(0, 0, 0);
 }

 .scrolled-link.active,
.dropdown-item.active {
  background-color:rgb(37, 85, 218);
  color: white;
  border-radius: 6px;
  padding: 5px 10px;
}

.mobile-menu a.active {
  background-color:rgb(37, 85, 218);
  color: white;
  border-radius: 6px;
  padding: 8px 12px;
  display: block;
}

.navbar {
  width: 100%;
  // background: rgba(0, 153, 255, 0.554);
  background: linear-gradient(to right,rgb(255, 255, 255),rgba(31, 115, 184, 0.66));

  // background: linear-gradient(to bottom right,rgba(0, 89, 255, 0.75),rgba(248, 244, 244, 0.74),rgba(0, 110, 255, 0.8));
  backdrop-filter: blur(17px);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
}

.navbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 20px;
  max-width: 1500px;
  margin: auto;
}



/* Logo */
.logo {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 10px;
}

.logo a {
  font-size: 24px;
  font-weight: bold;
  text-decoration: none;
  color: #fcfcfc;
}

.logo span {
  color:rgb(0, 202, 252);
  text-shadow: 0 0 2px rgb(255, 255, 255);
}

/* Desktop Navigation */
.nav-links {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  white-space: nowrap;
}

.nav-right {
  flex: 0 0 auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
}

.get-started-link {
  text-decoration: none;
}

.nav-links a {
  text-decoration: none;
  color:rgb(6, 0, 59);
  font-size: 17px;
  font-weight: 600;
  transition: 0.3s;
  // text-shadow: 0 0.5px 2px rgb(0, 0, 0);
}

.nav-links a:hover {
  color: #e1e1e1c0;
}

/* Get Started Button */
.get-started-btn {
  background: #007bff;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-size: 15px;
  transition: 0.3s;
}

.get-started-btn:hover {
  background: #0056b3;
}

/* Mobile Menu Button */
.menu-toggle {
  display: none;
  background: none;
  border: none;
  color: rgb(6, 0, 59);
  cursor: pointer;
  padding: 4px;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.menu-toggle:hover {
  transform: scale(1.08);
}

/* Mobile Navigation */
.mobile-menu {
  display: none;
  flex-direction: column;
  position: absolute;
  top: 58px;
  left: 0;
  z-index: 2;
  // margin-bottom: 30px;
  width: 100%;
  background: white;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 10px 0;
  max-height: 80vh;     
  overflow-y: auto;
}

.scrolled-logo{
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ll{
  height: 65px;
  width: 195px;
  position: relative;
  background-image: url("/images/log.png");
  background-size: contain;
  background-position: center left;
  background-repeat: no-repeat;
  mix-blend-mode: multiply;
  animation: logoSlideZoom 0.7s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

@keyframes logoSlideZoom {
  0% {
    opacity: 0;
    transform: translateX(-40px) scale(0.7);
  }
  60% {
    transform: translateX(6px) scale(1.05);
  }
  100% {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

.mobile-menu a {
  padding: 10px 20px;
  text-decoration: none;
  color: #333;
  display: block;
  transition: 0.3s;
}

.mobile-menu a:hover {
  background: #f0f0f0;
  zindex: 9;
}

/* ==================== MODERN DROPDOWN STYLES ==================== */

.dropdown-arrow {
  transition: transform 0.3s ease;
  color: rgb(6, 0, 59);
}

.dropdown:hover .dropdown-arrow {
  transform: rotate(180deg);
  color: white;
}

/* Desktop Dropdown */
.dropdown {
  position: relative;
  color: white;
  font-weight: 600;
  font-size: 17px;
  bottom: 1px;
}

.dropdown:hover {
  color: #e1e1e1c0;
} 

.modern-dropdown {
  position: absolute;
  background: white;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(148, 163, 184, 0.2);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3), 
              inset 0 1px 0 rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 12px 0;
  top: 100%;
  right: 0;
  display: none;
  min-width: 500px;
  max-height: 420px;
  overflow-y: auto;
  z-index: 100;
  margin-top: 0px;
  animation: dropdownAppear 0.3s ease forwards;
  scrollbar-width: thin;
  scrollbar-color: rgba(59, 130, 246, 0.4) transparent;
}

.modern-dropdown::-webkit-scrollbar {
  width: 6px;
}

.modern-dropdown::-webkit-scrollbar-track {
  background: transparent;
  border-radius: 10px;
}

.modern-dropdown::-webkit-scrollbar-thumb {
  background: rgba(59, 130, 246, 0.4);
  border-radius: 10px;
}

.modern-dropdown::-webkit-scrollbar-thumb:hover {
  background: rgba(59, 130, 246, 0.7);
}

@keyframes dropdownAppear {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdown:hover .modern-dropdown {
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  padding: 16px;
}

.modern-dropdown-item {
  position: relative;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: rgb(226, 232, 240);
  border-radius: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  font-size: 14px;
  font-weight: 500;
  gap: 12px;
  animation: itemSlideIn 0.4s ease backwards;
  animation-delay: calc(var(--item-index) * 0.05s);
}

@keyframes itemSlideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.modern-dropdown-item:hover {
  background-color: #e0f2ff;
  text:black;
  color: #e0f2fe;
  transform: translateX(4px);
}

.modern-dropdown-item.active {
  background: linear-gradient(135deg, rgb(37, 85, 218) 0%, rgb(59, 130, 246) 100%);
  color: white;
  box-shadow: 0 10px 30px rgba(59, 130, 246, 0.3);
}

.dropdown-item-content {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  position: relative;
  z-index: 2;
}

.dropdown-item-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: rgba(59, 130, 246, 0.2);
  border-radius: 8px;
  color: rgb(148, 163, 184);
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.modern-dropdown-item:hover .dropdown-item-icon {
  background: rgba(59, 130, 246, 0.4);
  color: #93c5fd;
  transform: translateX(4px);
}

.modern-dropdown-item.active .dropdown-item-icon {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.dropdown-item-text {
  flex: 1;
}

.dropdown-item-name {
  display: block;
  font-weight: 500;
  color: black;
  line-height: 1.4;
  letter-spacing: 0.3px;
}

.dropdown-item-hover-bg {
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(34, 197, 94, 0.05) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 12px;
  z-index: 1;
}

.modern-dropdown-item:hover .dropdown-item-hover-bg {
  opacity: 1;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .navbar-container {
    padding: 8px 16px;
  }

  .logo {
    padding-left: 0;
  }

  .ll {
    height: 55px;
    width: 165px;
  }

  .nav-links {
    gap: 14px;
  }

  .scrolled-link,
  .nav-links a {
    font-size: 15px;
  }

  .dropdown {
    font-size: 15px;
  }

  .get-started-btn {
    padding: 7px 14px;
    font-size: 14px;
  }

  .modern-dropdown {
    min-width: 500px;
  }
}

@media (max-width: 1024px) {
  .navbar-container {
    padding: 6px 12px;
  }

  .ll {
    height: 50px;
    width: 150px;
  }

  .nav-links {
    gap: 10px;
  }

  .scrolled-link,
  .nav-links a {
    font-size: 14px;
    gap: 4px;
  }

  .dropdown {
    font-size: 14px;
  }

  .get-started-btn {
    padding: 6px 12px;
    font-size: 13px;
  }

  .modern-dropdown {
    min-width: 440px;
  }
}

@media (max-width: 850px) {
  .nav-links {
    display: none !important;
  }

  .menu-toggle {
    display: flex;
  }

  .get-started-btn {
    padding: 8px 14px;
    font-size: 13.5px;
  }

  .mobile-menu.open {
    display: flex;
    margin-top: 14px;
  }
}

@media (max-width: 600px) {
  .ll {
    height: 45px;
    width: 135px;
  }

  .get-started-link {
    display: none;
  }
}

/* ==================== MOBILE DROPDOWN STYLES ==================== */

.mobile-dropdown {
  margin: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.mobile-dropdown-title {
  width: 100%;
  padding: 12px 20px;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(34, 197, 94, 0.05) 100%);
  border: none;
  cursor: pointer;
  color: rgb(37, 85, 218);
  font-size: 16px;
  transition: all 0.3s ease;
}

.mobile-dropdown-title:hover {
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(34, 197, 94, 0.1) 100%);
}

.mobile-dropdown-arrow {
  transition: transform 0.3s ease;
  color: rgb(37, 85, 218);
}

.mobile-dropdown-arrow.open {
  transform: rotate(180deg);
}

.mobile-dropdown-menu {
  background: rgba(59, 130, 246, 0.05);
  padding: 8px 0;
  max-height: 320px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(59, 130, 246, 0.4) transparent;
  animation: mobileDropdownOpen 0.3s ease;
}

.mobile-dropdown-menu::-webkit-scrollbar {
  width: 5px;
}

.mobile-dropdown-menu::-webkit-scrollbar-track {
  background: transparent;
}

.mobile-dropdown-menu::-webkit-scrollbar-thumb {
  background: rgba(59, 130, 246, 0.4);
  border-radius: 10px;
}

@keyframes mobileDropdownOpen {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 320px;
  }
}

.mobile-dropdown-menu a {
  padding: 10px 40px;
  display: block;
  color: rgb(37, 85, 218);
  text-decoration: none;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
}

.mobile-dropdown-menu a:hover {
  background: rgba(59, 130, 246, 0.1);
  border-left-color: rgb(37, 85, 218);
  padding-left: 44px;
}

.mobile-dropdown-menu a.active {
  background: rgb(37, 85, 218);
  color: white;
  border-left-color: white;
}

        `}
      </style>
    </>
  );
}
